import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DrivingSchoolInformation.module.scss'
import { drivingSchoolNameAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const DrivingSchoolName = ({ t, validateDrivingSchoolName, drivingSchoolNameError, drivingSchoolNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const drivingSchoolName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.drivingSchoolName)

  const handleDrivingSchoolName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(drivingSchoolNameAction(name))
      validateDrivingSchoolName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurDrivingSchoolName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(drivingSchoolNameAction(name))
      validateDrivingSchoolName(drivingSchoolName)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        drivingSchoolNameValid === true
          ? drivingSchoolName === ''
            ? ''
            : 'form-group has-success'
          : drivingSchoolNameValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="DrivingSchoolName">
        {t('driving_school_information.name_of_driving_school')}
      </label>
      <input
        type="text"
        id="DrivingSchoolName"
        className="form-control"
        value={drivingSchoolName}
        onChange={handleDrivingSchoolName}
        onFocus={() => SetIsFocussed(true)}
        onBlur={onBlurDrivingSchoolName}
        autoComplete="off"
        maxLength="150"
      />
      {drivingSchoolNameValid === true ? (
        drivingSchoolName === '' ? (
          ''
        ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
      ) : drivingSchoolNameValid === false ? (
        <React.Fragment>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(drivingSchoolNameError)}</div>
        </React.Fragment>
      ) : (
            ''
          )}
    </div>
  )
}

export default withTranslation('common')(DrivingSchoolName)
